const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-display font-semibold text-xl text-[#222]">{title}</h2>
    <div className="text-[#444] space-y-2 text-[15px] leading-relaxed">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="terms-page">
      <h1 className="text-3xl sm:text-4xl font-display font-bold mb-2">Terms &amp; Conditions</h1>
      <p className="text-[#717171] mb-8">Last updated {new Date().getFullYear()} · Ixitrip</p>

      <div className="space-y-8">
        <Section title="1. About Ixitrip">
          <p>Ixitrip operates an online travel marketplace that connects travelers with independent accommodation hosts and travel add-on providers. Ixitrip charges no commission to hosts; we facilitate discovery, booking, and payment between travelers and providers. Ixitrip is not the owner or operator of any listed property or service.</p>
        </Section>

        <Section title="2. Accounts">
          <p>You must provide accurate information when creating an account and are responsible for activity under your account. You must be at least 18 years old to make a booking or list a property. We may suspend or block accounts that violate these terms.</p>
        </Section>

        <Section title="3. Bookings &amp; payments">
          <p>A booking is confirmed once payment is successfully captured through our payment partner (Razorpay). Prices shown include applicable taxes (GST) and an Ixitrip convenience fee, which is displayed before payment. Hosts set their own nightly prices and availability.</p>
        </Section>

        <Section title="4. Cancellations &amp; refunds">
          <p>Travelers may cancel a confirmed booking subject to the following policy:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Full refund</strong> when you cancel <strong>48 hours or more before check-in</strong>.</li>
            <li><strong>50% refund</strong> when you cancel <strong>less than 48 hours before check-in</strong>.</li>
            <li><strong>No refund</strong> for cancellations after check-in or for no-shows.</li>
          </ul>
          <p>The convenience fee and GST on that fee are non-refundable. Refunds are issued to the original payment method within 2–5 business days. See our full <a href="/cancellation-policy" className="text-[#FF385C] font-medium">Cancellation Policy</a>.</p>
        </Section>

        <Section title="5. Host responsibilities">
          <p>Hosts are responsible for the accuracy of their listings, the condition and legality of their properties, honoring confirmed bookings, and complying with local laws, licenses, and tax obligations. Ixitrip may remove listings that are inaccurate, unsafe, or non-compliant.</p>
          <p>It will take 7 working days to verify the documents. Properties remain live during this period subject to final approval.</p>
        </Section>

        <Section title="6. Prohibited conduct">
          <p>You agree not to misuse the platform, post fraudulent listings, circumvent payments, or infringe others' rights. Ixitrip reserves the right to remove content and terminate accounts for violations.</p>
        </Section>

        <Section title="7. Limitation of liability">
          <p>Ixitrip provides the marketplace "as is" and is not liable for the acts or omissions of hosts, providers, or travelers. To the maximum extent permitted by law, our liability for any claim is limited to the Ixitrip convenience fee paid for the relevant booking.</p>
        </Section>

        <Section title="8. Changes to these terms">
          <p>We may update these terms from time to time. Continued use of Ixitrip after changes take effect constitutes acceptance of the revised terms.</p>
        </Section>

        <Section title="9. Contact">
          <p>Questions? Email <a href="mailto:customerservice@ixitrip.com" className="text-[#FF385C] font-medium">customerservice@ixitrip.com</a>.</p>
        </Section>
      </div>
    </div>
  );
}
